import React from 'react'
import proj from './Projects.module.css'
import { PageHeader } from '../PageHeader/PageHeader'
import freshly from './../../img/freshly.png'
import cricinfo from './../../img/cricinfo.png'
import paytm from './../../img/paytm.png'
import gitS from './../../img/githubLogoSmall.png'



const Projects = () => {

    return (
        <div className={proj.projects} id="projects" >
            <PageHeader title={'Projects'} />
            <div className={proj.container}>
                
                <div className={proj.project}>
                    <img className={proj.thumbnail}  src={paytm} alt="paytm-bus" />
                    {/* <span>Paytm-bus clone</span> */}    
                    <div className={proj.info}>
                    <div className={proj.link}>
                        <a href="https://paytmbus.vercel.app/" target="_blank">
                            <span>Paytm-bus clone</span>
                            <span>
                                <img style={{height:'15px', marginLeft:'-8px'}} src="https://img.icons8.com/ios-filled/50/000000/mouse-left-click.png" alt="click" />
                            </span>
                        </a>
                    </div>
                    <div className={proj.btnDiv}>
                        <a href="https://github.com/Afzal95/paytm-bus" target="_blank">
                            <img  style={{height:'20px'}} src={gitS} alt="git hub logo" />
                        </a>
                        <a href="https://youtu.be/CR2IwvaP5TY" target="_blank">
                            <img style={{height:'25px'}} src="https://img.icons8.com/color/48/000000/youtube-play.png"/>
                        </a>
                    </div>
                </div>
                </div>
              
                
                <div className={proj.project}>
                    <img className={proj.thumbnail}  src={cricinfo} alt="cricinfo" />
                    {/* <span>ESPNcricinfo.com clone</span> */}
                    <div className={proj.info}>
                        <div className={proj.link}>
                            <a href="https://cricinfo.vercel.app/" target="_blank">
                                <span>ESPNcricinfo.com clone</span>
                                <span>
                                    <img style={{height:'15px', marginLeft:'-8px'}} src="https://img.icons8.com/ios-filled/50/000000/mouse-left-click.png" alt="click" />
                                </span>
                            </a>
                        </div>
                        <div className={proj.btnDiv}>
                            <a href="https://github.com/Raushan8271/cricinfo" target="_blank">
                                <img  style={{height:'20px'}} src={gitS} alt="git hub logo" />
                            </a>
                            <a href="#">
                                <img style={{height:'25px'}} src="https://img.icons8.com/color/48/000000/youtube-play.png"/>
                            </a>
                        </div>
                    </div>
                </div>
            
                
                <div className={proj.project}>
                    <img className={proj.thumbnail}  src={freshly} alt="freshly" />
                    <div className={proj.info}>
                        <div className={proj.link}>
                            <a href="https://freshly-clone.netlify.app/" target="_blank">
                                <span>Fresly.com clone</span>
                                <span>
                                    <img style={{height:'15px', marginLeft:'-8px'}} src="https://img.icons8.com/ios-filled/50/000000/mouse-left-click.png" alt="click" />
                                </span>
                            </a>
                        </div>
                        <div className={proj.btnDiv}>
                            <a href="https://github.com/Hinduraj8199/freshly.com_Project" target="_blank">
                                <img  style={{height:'20px'}} src={gitS} alt="git hub logo" />
                            </a>
                            <a href="#">
                                <img style={{height:'25px'}} src="https://img.icons8.com/color/48/000000/youtube-play.png"/>
                            </a>
                        </div>
                    </div>
                </div> 
            

            </div>
        </div>
    )
}

export {Projects}

